
import { Link } from "react-router-dom";
import { Grid, ArrowRight } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

const FooterProducts = () => {
  const isMobile = useIsMobile();
  
  const products = [
    { name: "Kulutusluotto", path: "/lainat/kulutusluotto", title: "Kulutusluotto - joustava rahoitus erilaisiin tarpeisiin" },
    { name: "Asuntolaina", path: "/lainat/asuntolaina", title: "Asuntolaina - rahoitus unelmiesi kotiin" },
    { name: "Autolaina", path: "/lainat/autolaina", title: "Autolaina - rahoitus autoon joustavilla ehdoilla" },
    { name: "Joustoluotto", path: "/lainat/joustoluotto", title: "Joustoluotto - joustava luotto, josta voit nostaa rahaa tarpeen mukaan" },
    { name: "Yhdistelylaina", path: "/lainat/yhdistelylaina", title: "Yhdistelylaina - yhdistä lainasi edullisemmin ja säästä korkokuluissa" },
    { name: "Remonttilaina", path: "/lainat/remonttilaina", title: "Remonttilaina - rahoitus kodin remontointiin ja arvon nostamiseen" },
    { name: "Häälaina", path: "/lainat/haalaina", title: "Häälaina - rahoitusratkaisu unelmiesi häihin" },
    { name: "Yrityslaina", path: "/lainat/yrityslaina", title: "Yrityslainat - rahoitusratkaisut yrityksille investointeihin ja kasvuun" },
    { name: "Pikalaina", path: "/lainat/pikalaina", title: "Pikalaina - nopeat lainat äkillisiin tarpeisiin" },
    { name: "Venelaina", path: "/lainat/venelaina", title: "Venelaina - rahoitus veneen hankintaan" },
    { name: "Lomalaina", path: "/lainat/lomalaina", title: "Lomalaina - rahoitus unelmiesi lomamatkaan" },
    { name: "Caravanrahoitus", path: "/lainat/caravanrahoitus", title: "Caravanrahoitus - rahoitus matkailuauton hankintaan" },
    { name: "Mökkilaina", path: "/lainat/mokkilaina", title: "Mökkilaina - rahoitus vapaa-ajan asunnon hankintaan" },
    { name: "Moottoripyörälaina", path: "/lainat/moottoripyoralaina", title: "Moottoripyörälaina - rahoitus moottoripyörän hankintaan" },
    { name: "Pienkonelaina", path: "/lainat/pienkonelaina", title: "Pienkonelaina - rahoitus pienkoneiden hankintaan" },
    { name: "Pienlainat", path: "/lainat/pienlainat-luottokortit", title: "Pienlainat & luottokortit - pienet lainat ja luottokortit arkeen" }
  ];
  
  // Split products into columns for better organization
  const leftColumn = products.slice(0, 8);
  const rightColumn = products.slice(8, 16);
  
  return (
    <div className="flex flex-col items-center">
      <h3 className="text-lg font-semibold mb-4 text-white flex items-center justify-center">
        <Grid className="h-5 w-5 text-blue-300 mr-2" />
        Tuotteet
      </h3>
      <div className={cn("grid grid-cols-2 gap-x-4 gap-y-2", isMobile ? 'w-full max-w-xs' : 'w-full max-w-lg')}>
        <div className="space-y-2">
          {leftColumn.map((product) => (
            <div key={product.path}>
              <Link 
                to={product.path} 
                className="bg-blue-700 hover:bg-blue-600 transition-colors text-white py-1.5 px-2 rounded text-center text-sm hover:scale-105 transform duration-200 w-full flex items-center justify-center group"
                aria-label={product.title}
                title={product.title}
              >
                <ArrowRight className="h-3 w-0 text-yellow-300 mr-0 transition-all duration-300 group-hover:w-3 group-hover:mr-1" />
                {product.name}
              </Link>
            </div>
          ))}
        </div>
        
        <div className="space-y-2">
          {rightColumn.map((product) => (
            <div key={product.path}>
              <Link 
                to={product.path} 
                className="bg-blue-700 hover:bg-blue-600 transition-colors text-white py-1.5 px-2 rounded text-center text-sm hover:scale-105 transform duration-200 w-full flex items-center justify-center group"
                aria-label={product.title}
                title={product.title}
              >
                <ArrowRight className="h-3 w-0 text-yellow-300 mr-0 transition-all duration-300 group-hover:w-3 group-hover:mr-1" />
                {product.name}
              </Link>
            </div>
          ))}
        </div>

        <div className="col-span-2 mt-2 text-center">
          <Link 
            to="/lainatuotteet" 
            className="text-white hover:text-yellow-200 transition-colors font-medium flex items-center group justify-center"
            aria-label="Kaikki lainatuotteet - selaa koko lainavalikoimaamme"
            title="Tutustu kaikkiin lainatuotteisiimme"
          >
            <ArrowRight className="h-4 w-4 text-yellow-400 mr-1" />
            Kaikki lainatuotteet
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FooterProducts;
